const breakpoints = {
    xs: "375px",
    sm: "425px",
    md: "992px",
    lg: "1200px",
    xl: "1440px"
};

export default breakpoints;
